import { IOrganisationUserEdit } from '@liquid-state/pephealth-client';
import { DashboardUser } from './types';

export type DashboardUserOrganisationUserEditValues = {
  firstName: string;
  lastName: string;
  language: string;
  phoneNumber?: string;
  careTeamFlag: boolean;
};

/** Build a partial pephealth Organisation User edit from changed own-Organisation fields only. */
export const toDashboardUserOrganisationUserEdit = (
  currentUser: DashboardUser,
  values: DashboardUserOrganisationUserEditValues,
): IOrganisationUserEdit => {
  const edit: IOrganisationUserEdit = {};

  if (values.firstName !== currentUser.firstName) edit.firstName = values.firstName;
  if (values.lastName !== currentUser.lastName) edit.lastName = values.lastName;
  if (values.language !== currentUser.language) edit.language = values.language;
  if (values.phoneNumber !== (currentUser.phoneNumber || '')) {
    edit.phoneNumber = values.phoneNumber;
  }
  if (values.careTeamFlag !== Boolean(currentUser.careTeamMember)) {
    edit.careTeamMember = values.careTeamFlag;
  }

  return edit;
};
